<script setup>

const colorMode = useColorMode()

const props = defineProps({
  playlists: {
    type: Array,
		default: []
  }
})

const showMore = ref(false)

</script>

<template>
	<div class="mb-8 xl:mb-20">
		<h1 class="text-green xl:text-center max-w-[800px] mx-auto mb-5 xl:mb-10">{{ $t('license.playlists') }}</h1>
		<div class="grid grid-cols-12 gap-4 xl:gap-8">
			<div v-for="(playlist, index) in playlists" :key="index" class="col-span-12 xl:col-span-4" :class="{'hidden' : index > 2 && !showMore}">
				<iframe class="min-h-[850px]" :src="`${playlist.id}?theme=${colorMode.preference}`" style="border: none; width: 100%; height: 100%;"></iframe>
			</div>
		</div>
		<LoadMore v-if="!showMore" smallGrid @click="showMore = true" />
	</div>
</template>